export default __webpack_public_path__ + "static/media/pope_worldwide.63db5dfe.svg";